/**
 * Message category colors — consumed by Chat via theme.palette keys.
 *
 * DB/API message_categories.color values map as:
 *   info    → primary
 *   warning → warning
 *   success → success
 *   danger  → error
 *
 * Chat bubbles use palette `main`; admin previews/labels use `light`.
 * Edit the hex values below to change message colors per theme.
 */

/** MUI default light palette (+ existing app primary blue[500]). */
export const lightMessageCategoryPalette = {
  primary: {
    main: '#2196f3',
    light: '#42a5f5',
    dark: '#1565c0'
  },
  warning: {
    main: '#ed6c02',
    light: '#ff9800',
    dark: '#e65100'
  },
  success: {
    main: '#2196f3',
    light: '#42a5f5',
    dark: '#1565c0'
  },
  error: {
    main: '#d32f2f',
    light: '#ef5350',
    dark: '#c62828'
  }
}

/** MUI default dark palette. */
export const darkMessageCategoryPalette = {
  primary: {
    main: '#90caf9',
    light: '#e3f2fd',
    dark: '#42a5f5'
  },
  warning: {
    main: '#ffa726',
    light: '#ffb74d',
    dark: '#f57c00'
  },
  success: {
    main: '#90caf9',
    light: '#e3f2fd',
    dark: '#42a5f5'
  },
  error: {
    main: '#f44336',
    light: '#e57373',
    dark: '#d32f2f'
  }
}
